module.exports = __webpack_public_path__ + "img/Team.027c51cf.svg";